import { render } from "./TextSubmitRow.vue?vue&type=template&id=74b697d5"
import script from "./TextSubmitRow.vue?vue&type=script&lang=js"
export * from "./TextSubmitRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__